import Button from "../../../Buttons/Button";
import React, {
  FormEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useForm } from "react-hook-form";
import { inactiveItens, secondary } from "../../../../theme";
import { useApi } from "../../../../hooks/api";
import { useGlobal } from "../../../../hooks/global";
import { ModalLoading } from "../../../Loadings/ModalLoading";
import { IGroupProps } from "../../../../interfaces";
import { ContainerButtons, Content, Form } from "./style";
import { IGenericFormRefProps } from "../../../GenericForm";
import { validateCEP, validateCNPJ, validateEmail, validatePhone } from "../../../../utils/validatesFields";
import { managedAccommodationsOptions, positionTypeOptions } from "../../../../utils/options";
import DEFAULT_LOGO from '../../../../assets/web-check-in-default-logo.png';
import { BagForm } from "../../../BagForm";
import { FaUser } from "react-icons/fa";
import { MdLocationOn, MdOutlineAppRegistration } from "react-icons/md";
import { BoxIntregrationsCard } from "../style";
import { IntegrationCards } from "../IntegrationsCard";
import { Bag } from "../../../Bags/Bag";
import { AiFillApi } from "react-icons/ai";

export interface IGuestsDocumentsCardRef {
  matchImages: () => Promise<{
    isVerified: any;
    idGuest: string | undefined;
    compareValid: any;
    compareScore: any;
  }>;
}

interface IFormBusinessModalProps {
  onCancel: Function;
  onSave: Function;
  defaultData?: any;
}

export const FormBusiness: React.FC<IFormBusinessModalProps> = (
  props
) => {
  const { onSave, defaultData, onCancel } = props;

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setError,
    setValue,
    trigger,
    clearErrors
  } = useForm({
    defaultValues: defaultData?.id ? defaultData : ({} as any),
    mode: "all",
  });

  const _form = watch();

  const { api, consultsServices, user } = useApi();
  const { theme, notify, } = useGlobal();

  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingCEP, setLoadingCEP] = useState(false)

  const form_ref = useRef<IGenericFormRefProps>(null)
  const buttonSubmitRef = useRef<HTMLButtonElement>(null)

  const changeCEP = useCallback(async (search) => {
    search = search.replace(/\D/g, "")
    if (search.length === 8) {
      setLoadingCEP(true)

      const { address, city, state } = await consultsServices.address({ search })

      if (address) {
        setValue("street", address.logradouro)
        setValue("neighborhood", address.bairro)
        setValue("address_complement", address.complemento)
      }

      if (city) setValue("city_id", { label: city.name, value: city.id, this: city })

      if (state) setValue("state_id", { label: state.name, value: state.id, initials: state.initials, this: state })

      setLoadingCEP(false)

      trigger()
    }
  }, []);

  const transformDefaultLogoInBase64 = useCallback(async () => {
    try {
      const response = await fetch(DEFAULT_LOGO);
      const blob = await response.blob();

      const file = new File([blob], "web-check-in-default-logo.png", { type: blob.type });

      const formData = new FormData();
      formData.append("photo", file);

      const { data } = await api.post("/photos/transform", formData);

      return data.complete
    } catch (err) {
      console.error(err);
    }
  }, []);

  const onSubmit = useCallback(async (event) => {
    setLoadingSave(true)

    const form = form_ref.current?.getForm();

    const logo = await transformDefaultLogoInBase64();

    const {
      zip_code,
      city_id,
      state_id,
      address_complement,
      neighborhood,
      address_number,
      street,
    } = form.address;

    const {
      legal_name,
      trade_name,
      cnpj,
      phone_business,
      email_business,
    } = form.business;

    const {
      managed_accommodations,
      email,
      surname,
      password,
      phone,
      position,
    } = form.responsible;

    const business = {
      legal_name,
      trade_name,
      cnpj,
      zip_code,
      phone: phone_business,
      email: email_business,
      state_id,
      city_id,
      address_complement,
      neighborhood,
      address_number,
      street,
      managed_accommodations,
      logo,
    }

    const responsible = {
      surname,
      position,
      phone,
      email,
      password,
    }

    const data = { business, responsible }

    try {
      if (defaultData?.id) {
        await api.put(`/business/${defaultData?.id}`, { ...business });
      } else {
        await api.post("/create-new-account", data);
      }

      if (defaultData?.id) notify("Empresa atualizado com sucesso", "success");
      else notify('Empresa cadastrada com sucesso!', "success");

      onSave();
    } catch (err: any) {
      const error = err.response ? err.response.data : "SERVER ERROR";

      if (error.field) {
        setError(error.field, { type: "manual", message: error.detail });
      }

      if (error.path) setError(error.path, { type: "manual", message: error.message })
      else notify("ERRO INTERNO DO SISTEMA", "error")
    }

    setLoadingSave(false)

  }, [form_ref, api, _form])

  const handleStopPropagation = useCallback((e: FormEvent<HTMLFormElement>) => {
    e?.stopPropagation()
    handleSubmit(onSubmit)(e)
  }, [handleSubmit, onSubmit, form_ref, _form, api])

  const groups: IGroupProps[] = [
    {
      name: "responsible",
      label: "Responsável",
      icon: FaUser,
      fields: [
        [
          {
            name: "surname",
            label: "Responsável legal",
            type: "input",
            required: true
          }
        ],
        [
          {
            name: "position",
            label: "Cargo",
            type: "select-fixed",
            options: positionTypeOptions,
            required: true
          },
          {
            name: "managed_accommodations",
            label: "Acomodações administradas",
            type: "select-fixed",
            options: managedAccommodationsOptions,
            required: true
          }
        ],
        [
          {
            name: "phone",
            label: "Telefone",
            type: "input",
            mask: "phone",
            validate: validatePhone,
            required: true
          },
          {
            name: "email",
            label: "Email",
            type: "input",
            validate: validateEmail,
            required: true
          }
        ],
        [
          {
            name: "password",
            label: "Senha",
            type: "input",
            required: true,
            isPassword: true,
            noUpperCase: true,
            canSee: (data: any) => !defaultData?.id,
          },
        ]
      ],
      canSee: (data: any) => !defaultData?.id || !!user?.is_root,
    },
    {
      name: "business",
      label: "Dados de Registro",
      icon: MdOutlineAppRegistration,
      fields: [
        [
          {
            name: "legal_name",
            label: "Razão Social",
            type: "input",
            required: true
          },
          {
            name: "trade_name",
            label: "Nome Fantasia",
            type: "input",
            required: true
          }
        ],
        [
          {
            name: "cnpj",
            label: "CNPJ",
            type: "input",
            mask: "cnpj",
            validate: validateCNPJ,
            required: true
          },
        ],
        [
          {
            name: "phone_business",
            label: "Telefone",
            type: "input",
            mask: "phone",
            validate: validatePhone,
            required: true
          },
          {
            name: "email_business",
            label: "Email",
            type: "input",
            validate: validateEmail,
            required: true
          }
        ]
      ]
    },
    {
      name: "address",
      label: "Dados de Endereço",
      icon: MdLocationOn,

      fields: [
        [
          {
            name: "zip_code",
            label: "CEP",
            type: "input",
            mask: "cep",
            validate: validateCEP,
            executeOnChange: changeCEP,
            required: true,
          },
          {
            name: "state_id",
            label: "Estado",
            type: "select-single-no-creatable",
            isClearable: true,
            searchOptions: consultsServices.state_id,
            executeOnChange: async () => setValue("city_id", null),
            required: true,
          },
          {
            name: "city_id",
            label: "Cidade",
            type: "select-single-no-creatable",
            isClearable: true,
            searchOptions: consultsServices.city_id,
            additionalsQueries: (data: any) => ({ state_id: data?.state_id?.value }),
            getIsDisabled: (data: any) => !data?.state_id,
            required: true,
          }
        ],
        [
          {
            name: "neighborhood",
            label: "Bairro",
            type: "input"
          },
          {
            name: "street",
            label: "Logradouro",
            type: "input"
          },
          {
            name: "address_number",
            label: "Número",
            type: "input",
            mask: "onlyNumber"
          },
          {
            name: "address_complement",
            label: "Complemento",
            type: "input"
          }
        ]
      ]
    },

  ]

  useEffect(() => {
    const fieldsWithErrors = Object.keys(errors);

    fieldsWithErrors.forEach((field) => {
      const fieldValue = watch(field);

      if (fieldValue) {
        clearErrors(field);
      }
    });
  }, [watch(), errors]);

  const formContentBefore = (
    defaultData?.integration_status && (
      <BoxIntregrationsCard>
        <Bag title="Integrações" description="Integrações conectadas da empresa" icon={<AiFillApi size={24} color={secondary[theme]} />}>
          <IntegrationCards
            integration_status={defaultData?.integration_status}
          />
        </Bag>
      </BoxIntregrationsCard>
    )
  )
  return (
    <>
      <Content>
        <Form onSubmit={handleStopPropagation}>
          <BagForm
            ref={form_ref}
            groups={groups}
            _form={_form}
            control={control}
            trigger={trigger}
            errors={errors}
            setValue={setValue}
            register={register}
            disabled={loadingSave || loadingCEP}
            contentBefore={formContentBefore}
          />

          <button
            ref={buttonSubmitRef}
            type="submit"
            style={{ display: "none" }}
          />
        </Form>
      </Content>

      <ContainerButtons theme={theme}>
        <Button
          onClick={() => onCancel()}
          background={inactiveItens[theme]}
          color={"#FFF"}
          style={{ padding: 8, maxWidth: 150, fontSize: 14 }}
          children="Voltar"
        />

        <Button
          onClick={() => buttonSubmitRef.current?.click()}
          background={secondary[theme]}
          color={"#FFF"}
          style={{ padding: 8, maxWidth: 150, fontSize: 14 }}
          children="Salvar"
          disabled={loadingCEP}
        />
      </ContainerButtons>

      <ModalLoading loading={loadingSave} theme={theme} />
    </>
  );
};
